import React from 'react';
import './HalloweenDecorations.css';

const Cobweb = ({ id }) => (
  <svg viewBox="0 0 120 120" className="halloween-decoration-svg" aria-hidden="true">
    <g stroke="#d9d4e7" strokeWidth="1" fill="none" opacity="0.8">
      {/* Radial threads from the corner */}
      <line x1="0" y1="0" x2="120" y2="0" />
      <line x1="0" y1="0" x2="110" y2="45" />
      <line x1="0" y1="0" x2="85" y2="85" />
      <line x1="0" y1="0" x2="45" y2="110" />
      <line x1="0" y1="0" x2="0" y2="120" />
      {/* Sagging concentric threads */}
      <path d="M 28 0 Q 24 24, 0 28" />
      <path d="M 52 0 Q 42 42, 0 52" />
      <path d="M 78 0 Q 62 62, 0 78" />
      <path d="M 104 0 Q 82 82, 0 104" />
    </g>
    {/* Dangling spider */}
    <g className="halloween-spider" id={id}>
      <line x1="70" y1="60" x2="70" y2="86" stroke="#d9d4e7" strokeWidth="1" opacity="0.8" />
      <ellipse cx="70" cy="93" rx="6" ry="5" fill="#2b1b3d" />
      <circle cx="70" cy="86" r="3" fill="#2b1b3d" />
      <circle cx="69" cy="85" r="0.8" fill="#ff8c00" />
      <circle cx="71" cy="85" r="0.8" fill="#ff8c00" />
    </g>
  </svg>
);

const HalloweenDecorations = () => {
  return (
    <>
      <div className="halloween-decoration halloween-top-left">
        <Cobweb id="spiderLeft" />
      </div>
      <div className="halloween-decoration halloween-top-right">
        <Cobweb id="spiderRight" />
      </div>
    </>
  );
};

export default HalloweenDecorations;
